const noop = () => {};

const conditionalValidation = (validator, validationEnabled = true) =>
  validationEnabled ? validator : noop;

export default conditionalValidation;
